'use strict'

import { Enum } from '@/app/model/base/enum'

/**
 * Тип материала:
 * 0 - для показа на экране
 */

export const values = {
  DISPLAY_SHOW: 0
}

class AdTextItemTypes extends Enum {

}

export default AdTextItemTypes.initEnum(values)
